import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';

interface FlexProps {
  gap?: number;
  align?: 'flex-start' | 'center' | 'flex-end' | 'stretch';
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around';
  wrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
}

export const Row = styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && !['gap', 'align', 'justify', 'wrap'].includes(prop)
})<FlexProps>`
  display: flex;
  flex-direction: row;
  gap: ${({ gap = 2, theme }) => theme.spacing(gap)};
  align-items: ${({ align = 'stretch' }) => align};
  justify-content: ${({ justify = 'flex-start' }) => justify};
  flex-wrap: ${({ wrap = 'nowrap' }) => wrap};
`;

export const Stack = styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && !['gap', 'align'].includes(prop)
})<Pick<FlexProps, 'gap' | 'align'>>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap = 2, theme }) => theme.spacing(gap)};
  align-items: ${({ align = 'stretch' }) => align};
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpaceBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
`;

interface GridProps {
  cols?: number;
  gap?: number;
  minWidth?: string;
}

export const Grid = styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && !['cols', 'gap', 'minWidth'].includes(prop)
})<GridProps>`
  display: grid;
  grid-template-columns: ${({ cols, minWidth = '200px' }) =>
    cols ? `repeat(${cols}, 1fr)` : `repeat(auto-fit, minmax(${minWidth}, 1fr))`};
  gap: ${({ gap = 4, theme }) => theme.spacing(gap)};
`;
